<div class="omni-search-container">
  <div class="omni-search-bar">
    @if (activeProvider()) {
      <div class="provider-chip">
        {{ activeProvider()?.label }}
        @if(!singleProvider()) {
          <button class="chip-clear" (click)="clearProvider()">×</button>
        }
      </div>
    }

    <input
      #searchInput
      type="text"
      pInputText
      [ngModel]="query()"
      (ngModelChange)="query.set($event); onInputChange()"
      (focus)="onFocus()"
      placeholder="Search..."
      class="search-input"
    />

    <button
      type="button"
      class="search-btn"
      (click)="onSearch()"
      [disabled]="!activeProvider() || loading() || query() === ''"
      [class.disabled]="!activeProvider() || loading()"
    >
      @if (!loading()) {
        <i class="pi pi-search"></i>
      } @else {
        <i class="pi pi-spin pi-spinner"></i>
      }
    </button>

  </div>


  <!-- Inline suggestion dropdown -->
  @if (showSuggestions() && suggestedProviders().length > 0) {
    <div class="omni-dropdown">
      @for (p of suggestedProviders(); let i = $index; track p.id) {
        <div
          class="dropdown-item"
          [class.focused]="highlightedIndex() === i"
          (click)="selectProvider(p, true)"
        >
          <span class="shortcut">{{ p.shortcut }}</span>
          <span class="label">{{ p.label }}</span>
        </div>
      }
    </div>
  }


  <!-- Provider palette (on click without typing) -->
  @if (showPalette() && !showSuggestions()) {
    <div #paletteContainer class="omni-palette">
      <div class="palette-header">Search in:</div>
      @for (group of groupedProviders(); let gIndex = $index; track group) {
        <div class="palette-group">
          <div class="palette-title">{{ group.subApp }}</div>
          @for (p of group.providers; let pIndex = $index; track p) {
            <div
              class="palette-item"
              [class.focused]="highlightedIndex() === _absoluteIndex(gIndex, pIndex)"
              (click)="selectProvider(p)"
            >
              <span>{{ p.label }} - {{ p.shortcut }}</span>
              @if (p.description) {
                <i class="pi pi-question-circle" pTooltip="{{ p.description }}"></i>
              }
            </div>
          }
        </div>
      }
    </div>
  }

  <!-- Search results -->
  @if (activeProvider() && results() && results()!.length > 0) {
    <div class="omni-palette">
      <div class="palette-header">{{ activeProvider()?.label }}</div>
      <div class="palette-group">
        @for (r of results(); track r) {
          @if (activeComponent()) {
            <div class="result-item" (click)="clearSearch()">
              <ng-container
                *ngComponentOutlet="
                  activeComponent();
                  inputs: { data: r.data, providerId: activeProvider()?.id }
                "
              ></ng-container>
            </div>
          }
        }
      </div>
    </div>
  } @else if (activeProvider() && results() && results()!.length === 0) {
    <div class="omni-palette">
      <div class="palette-header">{{ activeProvider()?.label }}</div>
      <div class="palette-group">
        <div class="no-results text-center">No results found</div>
      </div>
    </div>
  }
</div>
